/**
 * @generated SignedSource<<f9315c9101376642f2b080f33df352d6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedFeaturedModuleContent_viewer$data = {
  readonly onSaleVerticals: ReadonlyArray<{
    readonly category: string | null;
    readonly displayName: string | null;
    readonly linkData: {
      readonly path: string | null;
    };
  } | null> | null;
  readonly " $fragmentType": "HpSharedFeaturedModuleContent_viewer";
};
export type HpSharedFeaturedModuleContent_viewer$key = {
  readonly " $data"?: HpSharedFeaturedModuleContent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedFeaturedModuleContent_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedFeaturedModuleContent_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "OnSaleVertical",
      "kind": "LinkedField",
      "name": "onSaleVerticals",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "category",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "8eff05a339c27287c8a9703c93ded5e4";

export default node;
